// MENU BURGER
document.addEventListener("DOMContentLoaded", function () {
  const burger = document.querySelector(".header__burger");
  const header = document.querySelector(".header");

  burger.addEventListener("click", function () {
    header.classList.toggle("header-menu-open");
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('.menu-main');
  if (!menu) return;

  const itemsWithSubmenu = menu.querySelectorAll('li:has(ul)');

  const isMobile = () => window.matchMedia('(max-width: 768px)').matches;

  itemsWithSubmenu.forEach(li => {
    const link = li.querySelector('a');
    const submenu = li.querySelector('ul');


    link.addEventListener('click', e => {

      // MOBILE → slide + prevent
      if (isMobile()) {
        // slide styly
        submenu.style.overflow = 'hidden';
        submenu.style.maxHeight = '0px';
        submenu.style.transition = 'max-height 0.3s ease';

        e.preventDefault();
        e.stopPropagation();

        itemsWithSubmenu.forEach(item => {
          if (item !== li) {
            item.classList.remove('active');
            const ul = item.querySelector('ul');
            if (ul) ul.style.maxHeight = '0px';
          }
        });

        li.classList.toggle('active');

        if (li.classList.contains('active')) {
          submenu.style.maxHeight = submenu.scrollHeight + 'px';
        } else {
          submenu.style.maxHeight = '0px';
        }

      }
      // DESKTOP → jen toggle class
      else {
        e.preventDefault();
        e.stopPropagation();

        itemsWithSubmenu.forEach(item => {
          if (item !== li) item.classList.remove('active');
        });

        li.classList.toggle('active');
      }

    });
  });

  // ❌ MOBILE → nic
  // ✅ DESKTOP → zavírá při kliknutí mimo
  document.addEventListener('click', () => {
    if (isMobile()) return;

    itemsWithSubmenu.forEach(li => {
      li.classList.remove('active');
    });
  });

});

// contact form
document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("contact_form");
  if (!form) return;

  const submitBtn = form.querySelector('input[type="submit"]');

  form.addEventListener("submit", function () {
    submitBtn.disabled = true;
    submitBtn.classList.add("is-loading");

    const locale = "{{ request.locale.iso_code }}";
    submitBtn.value = locale === "en"
      ? "Sending..."
      : "Odosiela sa...";
  });
});

// FAQS
document.addEventListener('DOMContentLoaded', () => {
  const faqItems = document.querySelectorAll('.gen-faqs__item');

  faqItems.forEach(item => {
    const question = item.querySelector('.gen-faqs__item__question');
    const answer = item.querySelector('.gen-faqs__item__answer');

    // výchozí stav
    if (!item.classList.contains('active')) {
      answer.style.maxHeight = '0px';
    } else {
      answer.style.maxHeight = answer.scrollHeight + 'px';
    }

    question.addEventListener('click', () => {
      const isActive = item.classList.contains('active');

      // zavři všechny ostatní (volitelné)
      faqItems.forEach(i => {
        i.classList.remove('active');
        i.querySelector('.gen-faqs__item__answer').style.maxHeight = '0px';
      });

      if (isActive) {
        item.classList.remove('active');
        answer.style.maxHeight = '0px';
      } else {
        item.classList.add('active');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
});


// MODALS
document.addEventListener('DOMContentLoaded', () => {
  const modalButtons = document.querySelectorAll('.jsModalShower');
  const modalClosers = document.querySelectorAll('.jsModalHider');

  modalButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const modalId = btn.dataset.modalId;

      // close all modals
      document.querySelectorAll('.jsModalToShow.active').forEach(openModal => {
        openModal.classList.remove('active');
      });

      // open new modal
      const modal = document.querySelector(`.jsModalToShow[data-modal-id="${modalId}"]`);
      if (modal) {
        modal.classList.add('active');
      }
    });
  });

  modalClosers.forEach(closeBtn => {
    closeBtn.addEventListener('click', () => {
      const modal = closeBtn.closest('.jsModalToShow');
      if (modal) {
        modal.classList.remove('active');
      }
    });
  });

  // zavření kliknutím mimo obsah modalu
  document.querySelectorAll('.gen-popup-inner').forEach(inner => {
    inner.addEventListener('click', e => {
      if (e.target === inner) {
        document.querySelectorAll('.jsModalToShow.active').forEach(modal => {
          modal.classList.remove('active');
        });
      }
    });
  });

  // otevření modalu podle URL parametru
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('contact_posted') === 'true') {
    const modal = document.querySelector('.jsModalToShow[data-modal-id="modal-thank-you"]');
    if (modal) {
      modal.classList.add('active');
    }
  }
});



// swiper
document.addEventListener("DOMContentLoaded", () => {
  var swiper = new Swiper('.jsSwiperProductGallery .swiper', {
    loop: true,
    speed: 600,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 1,
    navigation: {
      prevEl: '.jsSwiperProductGallery .swiper-buttons-prev',
      nextEl: '.jsSwiperProductGallery .swiper-buttons-next',
    },
  });

});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.jsSwiperWornByIconsGallery').forEach((galleryEl) => {
    const swiperEl = galleryEl.querySelector('.swiper');
    const nextEl = galleryEl.querySelector('.swiper-buttons-next');
    const prevEl = galleryEl.querySelector('.swiper-buttons-prev');

    // const paginationEl = galleryEl.querySelector('.swiper__dots');

    new Swiper(swiperEl, {
      loop: true,
      speed: 600,
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 1,
      // autoplay: {
      //     delay: 3000,
      //     pauseOnMouseEnter: true,
      // },    
      // pagination: {
      //     el: paginationEl,
      //     clickable: true,
      // },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
    });
  });
});
